import "./BomProductsList.css";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDataLayerValue } from "../../../App/reducer/DataLayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCookies } from "react-cookie";
import {
  faSearch,
  faPlus,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

import Loading from "../../../App/components/Loading/Loading";
import TableHeader from "../../../App/components/shared/TableHeader";
import fetch_backend from "../../../App/components/shared/Fetch";
import { url_bom_products, url_bill_of_materials } from "../../constants/constants";

function BomProductsList() {
  const history = useHistory();
  const [{ actual_url }, dispatch] = useDataLayerValue();
  const [sortAscen, setSortAscen] = useState();
  const [clicked_column, setClicked_column] = useState("");
  const [json_response, setJson_response] = useState();
  const [backupJson_response, setBackupJson_response] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [cookies] = useCookies();
  const token = cookies.token_orders;

  const formatCurrency = (value) => {
    if (value == null || value === "") return "";
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  async function send_init_request() {
    setIsLoading(true);
    var response = await fetch_backend(
      "bill_materials/products/",
      "GET",
      token,
      dispatch
    );
    setJson_response(response);
    setBackupJson_response(response);
    setIsLoading(false);
  }

  const click_column = (col_name) => {
    setClicked_column(col_name);
  };

  function isNumeric(x) {
    let value = !isNaN(x) ? x : parseFloat(x.replace(/[\$,]/g, ""));
    return { isNum: !isNaN(value), value };
  }

  const sortFunction = (sub) => {
    setSortAscen(!sortAscen);
    const list = [...json_response.products];
    let nulls = list.filter((item) => item[sub] == null);
    let empty_str = list.filter((item) => item[sub] === "");
    let toSort = list.filter((item) => item[sub]);
    let sorted = toSort.sort((a, b) => {
      let aa = isNumeric(a[sub]);
      let bb = isNumeric(b[sub]);
      if (aa.isNum && bb.isNum) {
        return aa.value - bb.value;
      }
      return a[sub].toString().toLowerCase() > b[sub].toString().toLowerCase()
        ? 1
        : -1;
    });
    sorted = sorted.concat(nulls).concat(empty_str);
    if (!sortAscen) {
      sorted.reverse();
    }
    setJson_response({ ...json_response, products: sorted });
  };

  const handleSearch = (value) => {
    let newList = [...backupJson_response.products];
    if (value !== "") {
      const search = value.toLowerCase();
      newList = newList.filter(
        (row) =>
          (row.product_name &&
            row.product_name.toLowerCase().includes(search)) ||
          (row.size &&
            row.size.toLowerCase().includes(search)) ||
          (row.price != null && row.price.toString().includes(value)) ||
          (row.id && row.id.toString().includes(value))
      );
      setJson_response({ ...json_response, products: newList });
    } else {
      setJson_response(backupJson_response);
    }
  };

  const onFocusSearch = () => {
    setBackupJson_response(json_response);
  };

  const click_new_bom = () => {
    history.push(`${url_bill_of_materials}/detail`, {
      is_edit: false,
      is_new: true,
      bom_id: null,
      is_product: true,
    });
  };

  const click_product_detail = (row) => {
    history.push(`${url_bill_of_materials}/detail`, {
      is_edit: true,
      is_new: false,
      bom_id: row.id,
      is_product: true,
    });
  };

  useEffect(() => {
    dispatch({
      type: "SET_URL",
      actual_url: url_bom_products,
    });
    send_init_request();
  }, []);

  return (
    <div className="wrapped__container_top_bar bom-products-view">
      <Loading isLoading={isLoading} />

      <div className="top-bar">
        <h3>Hoja de Costos - Productos</h3>
      </div>

      <div className="search_div">
        <div className="search_container" style={{ flex: 0.5 }}>
          <input
            type="text"
            onChange={(event) => handleSearch(event.target.value)}
            onFocus={() => onFocusSearch()}
            placeholder="Buscar por producto, tamaño, precio o ID..."
          />
          <FontAwesomeIcon icon={faSearch} color="#383838" />
        </div>
        <div className="guides_tools" style={{ display: "flex", justifyContent: "flex-end", marginRight: "16px" }}>
          <div className="sub_guide_tools">
            <div
              className="square_agregar_tools"
              onClick={click_new_bom}
            >
              <p className="col_white agregar_label_btn">
                <FontAwesomeIcon icon={faPlus} style={{ marginRight: "6px" }} />
                Nuevo Producto
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="task-content">
        <table className="table_tasks">
          <thead>
            <tr className="rowHeaders">
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="ID"
                txt_filter="id"
                width="10%"
              />
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="Producto"
                txt_filter="product_name"
                width="40%"
              />
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="Tamaño"
                txt_filter="size"
                width="20%"
              />
              <TableHeader
                sortFunction={sortFunction}
                sortAscen={sortAscen}
                click_column={click_column}
                clicked_column={clicked_column}
                col_name="Precio"
                txt_filter="price"
                width="20%"
              />
              <TableHeader col_name="Detalle" width="10%" />
            </tr>
          </thead>
          <tbody>
            {json_response?.products?.map((row, index) => (
              <tr className="rowTasks" key={row.id || index}>
                <td>{row.id}</td>
                <td>{row.product_name}</td>
                <td>{row.size}</td>
                <td>{formatCurrency(row.price)}</td>
                <td>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    color="#383838"
                    className="iconRow"
                    onClick={() => click_product_detail(row)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {json_response && json_response.products?.length === 0 && (
          <div className="bom-list-empty">
            <p>No hay productos creados.</p>
            <button className="bom-list-empty-btn" onClick={click_new_bom}>
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: "6px" }} />
              Nuevo Producto
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default BomProductsList;
